import { i18n } from "@/i18n"

import { defineLazyProperty } from "../misc"

export function useDropdown() {}

/*#__NO_SIDE_EFFECTS__*/
export const getOptions = (
  enumObject: Record<string, string>,
  translationPath: string,
  ignore: string[] = []
) => {
  const values = Object.values(enumObject)

  const filteredValues = ignore.length ? values.filter((key) => !ignore.includes(key)) : values

  return filteredValues.map((key) => {
    const path = `${translationPath}${key.includes(".") ? `[${key}]` : `.${key}`}`
    return defineLazyProperty(
      {
        code: key,
      },
      "name",
      () => i18n.global.t(path, key)
    )
  })
}
